// Define Error Prefix
const ZIP_PREFIX = 1054;

// Define Error Codes
const MISSING_ZIP = ZIP_PREFIX + 1;
const SHORT_ZIP = ZIP_PREFIX + 2;
const INVALID_ZIP = ZIP_PREFIX + 3;

// Public Error Codes
export const ZIP_ERRORS = {
  MISSING_ZIP,
  SHORT_ZIP,
  INVALID_ZIP,
};

// Corresponding Error Messages
export const ZIP_ERROR_MESSAGES = {
  [MISSING_ZIP]: "Zip Required.",
  [SHORT_ZIP]: "Zip code must be 5 digits.",
  [INVALID_ZIP]: "Please enter a 5 digit zip code.",
};

export default class ZipValidator {
  static validateZip(zip_code) {
    let errors = [];

    // Short Phone
    if (!zip_code) {
      errors.push(MISSING_ZIP);
    }

    // Validate PHone By Regex
    if (!ZIPREGEX.test(zip_code)) {
      errors.push(INVALID_ZIP);
    }

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static constructErrorMessage(errors) {
    const message = [];

    errors.forEach((error) => {
      message.push(ZIP_ERROR_MESSAGES[error]);
    });

    return message.join(" ");
  }
}

const ZIPREGEX = /(^\d{5}$)|(^\d{5}-\d{4}$)/;



// WEBPACK FOOTER //
// ./client/app/services/validation/zip.js